import React from 'react';
import Icon from '../AppIcon';

const ProcessingStatusBadge = ({ 
  status = 'idle', 
  progress = 0, 
  message = '',
  className = '' 
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'processing':
        return {
          icon: 'Loader2',
          iconClass: 'animate-spin',
          bgColor: 'bg-warning',
          textColor: 'text-warning-foreground',
          borderColor: 'border-warning',
          label: 'Processing'
        };
      case 'completed':
        return {
          icon: 'CheckCircle',
          iconClass: '',
          bgColor: 'bg-success',
          textColor: 'text-success-foreground',
          borderColor: 'border-success',
          label: 'Complete'
        };
      case 'error':
        return {
          icon: 'AlertCircle',
          iconClass: '',
          bgColor: 'bg-error',
          textColor: 'text-error-foreground',
          borderColor: 'border-error',
          label: 'Error'
        };
      case 'paused':
        return {
          icon: 'Pause',
          iconClass: '',
          bgColor: 'bg-secondary',
          textColor: 'text-secondary-foreground',
          borderColor: 'border-secondary',
          label: 'Paused'
        };
      default:
        return null;
    }
  };

  const config = getStatusConfig();

  if (!config || status === 'idle') {
    return null;
  }

  return (
    <div className={`
      inline-flex items-center space-x-2 px-3 py-1.5 rounded-full text-xs font-medium
      ${config?.bgColor} ${config?.textColor} border ${config?.borderColor}
      transition-all duration-200 ease-smooth
      ${className}
    `}>
      <Icon 
        name={config?.icon} 
        size={12} 
        className={config?.iconClass}
      />
      <span>{config?.label}</span>
      {status === 'processing' && progress > 0 && (
        <span className="font-mono">
          {Math.round(progress)}%
        </span>
      )}
      {message && (
        <span className="hidden sm:inline text-xs opacity-90">
          • {message}
        </span>
      )}
      {status === 'processing' && progress > 0 && (
        <div className="w-16 h-1 bg-white bg-opacity-30 rounded-full overflow-hidden">
          <div 
            className="h-full bg-white transition-all duration-300 ease-smooth"
            style={{ width: `${Math.min(progress, 100)}%` }}
          />
        </div>
      )}
    </div>
  );
};

export default ProcessingStatusBadge;